// Copyright 2023 Sorama B.V.
import { autoinject } from "aurelia-framework";
import { LicenseKind } from "datatypes/SoramaWebApi";
import { Api } from "libraries/WebApi/Api";
import { IWebRequestHandler } from "libraries/WebRequestHandler/IWebRequestHandler";
import { Repository } from "repositories/Repository";

@autoinject
export class LicenseRepository extends Repository {
    private webRequestHandler: IWebRequestHandler;

    constructor(webRequestHandler: IWebRequestHandler) {
        super();
        this.webRequestHandler = webRequestHandler;
    }

    //#region Get Requests
    public getSellableFeatureLicenses(): Promise<LicenseKind[]> {
        return this.webRequestHandler
            .createGetRequest<LicenseKind[]>(Api.license + "/" + "SellableFeatureLicenses")
            .send()
            .then((x) => x.content)
            .catch(this.onError);
    }
    //#endregion

    public activateFeature(licenseId: string, deviceId: string, hardwareClock: number): Promise<string> {
        // Make web request and strip of http response message when returning an error
        return this.webRequestHandler
            .createGetRequest<string>(
                Api.license + "/" + licenseId + "/Activate?hardwareClock=" + hardwareClock + "&deviceId=" + deviceId
            )
            .send()
            .then((x) => x.content)
            .catch((e) => this.onError(e));
    }

    public encryptLicense(licenseId: string, deviceId: string, hardwareClock: number): Promise<string> {
        // Make web request and strip of http response message when returning an error
        return this.webRequestHandler
            .createGetRequest<string>(
                Api.license + "/" + licenseId + "/Encrypt?hardwareClock=" + hardwareClock + "&deviceId=" + deviceId
            )
            .send()
            .then((x) => x.content)
            .catch((e) => this.onError(e));
    }
}
